import _from from 'array.from';
_from.shim(); // Shim needed for IE11

import SortableHOC, { 
  SortableContainer, 
  SortableElement, 
  SortableHandle, 
  arrayMove 
} from 'react-sortable-hoc';

export {
  SortableContainer,
  SortableElement,
  SortableHandle,
  arrayMove
};
export default SortableHOC;